import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.867 25.251A12.96 12.96 0 0 0 16 29c3.56 0 6.786-1.43 9.133-3.749a1 1 0 0 0 .118-.118A12.96 12.96 0 0 0 29 16c0-3.56-1.431-6.786-3.75-9.134a1 1 0 0 0-.116-.117A12.96 12.96 0 0 0 16 3c-3.56 0-6.786 1.431-9.134 3.75a1 1 0 0 0-.117.116A12.96 12.96 0 0 0 3 16c0 3.56 1.43 6.786 3.749 9.133a1 1 0 0 0 .118.118M5 16c0-2.677.957-5.132 2.547-7.039l3.562 3.563A5.97 5.97 0 0 0 10 16c0 1.296.41 2.496 1.11 3.477l-3.563 3.562A10.96 10.96 0 0 1 5 16m3.961 8.453 3.563-3.562C13.504 21.589 14.704 22 16 22s2.496-.41 3.477-1.11l3.562 3.563A10.96 10.96 0 0 1 16 27c-2.677 0-5.132-.957-7.039-2.547m15.492-1.414-3.562-3.562A5.97 5.97 0 0 0 22 16c0-1.296-.41-2.496-1.11-3.476l3.563-3.563A10.96 10.96 0 0 1 27 16c0 2.677-.957 5.132-2.547 7.04M23.04 7.547l-3.562 3.562A5.97 5.97 0 0 0 16 10c-1.296 0-2.496.41-3.476 1.11L8.96 7.546A10.96 10.96 0 0 1 16 5c2.677 0 5.132.957 7.04 2.547M12 16a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconHelpCenter = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHelpCenter);
export default Memo;
